import OneDriveRedirect from "../OneDriveRedirect";
import UseSimulator from '../UseSimulator'
const TestSimulatorPage = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const uuid = params.get("uuid");
  const id = params.get("id");
  const markFlag = params.get("mark");
  const code = params.get("code");
  return (
    <>
      {!code ? (
        <UseSimulator uuid={uuid} assistantId={id} markFlag={markFlag} />
      ) : (
        <OneDriveRedirect />
      )}
    </>
  );
};

export default TestSimulatorPage;
